(function GroupEditForm($, Adzuki)
{
	"use strict";

	Adzuki.onload('Groups/edit/', init);

	function init() {
		GroupEditForm.maximizeClass = Adzuki.FaIcon.getIconStyle('expand', 'regular');
		GroupEditForm.minimizeClass = Adzuki.FaIcon.getIconStyle('collapse', 'regular');
		GroupEditForm.anchorTag     = $(location).attr('hash');

		$('#groupedit-group-online_registrations').on('change', toggleOnlineRegistration);
		$('#groupedit-group-online_registrations').change();
		$('#groupedit-group-insurance_company_id').on('change', toggleInsuranceSupplier);
		$('#groupedit-group-insurance_company_id').change();
		$('#toggle-content-fields').on('click', toggleContentFields);
		$('#groupedit-group-skip_payment').on('change', handleExcludePaymentInfo);
		$('#groupedit-group-single_payment_source').on('change', handleSinglePaymentSource);
		$('#groupedit-group-allow_cc').on('change', handleCardAuthorization);
		$('#groupedit-group-authorization_amount_type').on('change', handleSetAuthorizationAmountType);

		$('#groupedit-group-authorization_amount_type').change();
		$('#groupedit-group-allow_cc').change();

		if (GroupEditForm.anchorTag === '#content') {
			$('#toggle-content-fields').click();
			$('#group-content-div').collapse('toggle');
		}

		Adzuki.CharacterCount('#groupedit-group-website_offer_blurb', {
			max  : 250,
			label: '#website_offer_blurb-count',
		});

		Adzuki.Editor('#groupedit-group-about', {
			height                  : 400,
			content_css             : $('#groupedit-group-about').data('content-css'),
			table_default_attributes: {
				class: 'table'
			}
		});

		$('#groupedit-group-content_template').change(function updateContent(e) {
			var $self                = $(this),
			    template_id          = $self.val(),
			    previous_template_id = $('#groupedit-group-previous_content_template').val(),
			    current_content      = $('#groupedit-group-about').val();

			e.preventDefault();

			if (template_id === '' || template_id === previous_template_id) {
				return false;
			}

			if (current_content === '') {
				// no content, just set it
				updateBodyContent(template_id);

				// set the previous content to the one just selected
				$('#groupedit-group-previous_content_template').val(template_id);
			} else {
				// there's existing content, have agent confirm
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Selecting a Content Template will overwrite the existing content. Do you wish to continue?',
					confirm: function confirm() {
						// set the content
						updateBodyContent(template_id);

						// set the previous content to the one just selected
						$('#groupedit-group-previous_content_template').val(template_id);
					},
					cancel: function cancel() {
						// agent chose not to update, clear the template selection
						$self.val('');
					}
				});
			}
		});

		Adzuki.Editor('#groupedit-group-details', {
			height                  : 400,
			content_css             : $('#groupedit-group-details').data('content-css'),
			table_default_attributes: {
				class: 'table'
			}
		});

		Adzuki.Editor('#groupedit-group-terms', {
			height                  : 400,
			content_css             : $('#groupedit-group-terms').data('content-css'),
			table_default_attributes: {
				class: 'table'
			}
		});

		Adzuki.Editor('#groupedit-group-fax_instructions', {
			content_css             : $('#groupedit-group-fax_instructions').data('content-css'),
			table_default_attributes: {
				class: 'table'
			}
		});

		Adzuki.Editor('#groupedit-group-mail_instructions', {
			content_css             : $('#groupedit-group-mail_instructions').data('content-css'),
			table_default_attributes: {
				class: 'table'
			}
		});

		// update the preview when the modal for the visual lists
		// is hidden and the user makes a selection
		$('.modal').on('hidden.bs.modal', function onModalHidden()
		{
			$('#groupedit-group-content_template').trigger('change');
		});

		loadRequiredFields();
		setRequiredFields();
		loadLabels();

		$('.fields').click(function checkedBox() {
			if ($(this).prop('checked') === true) {
				addRequiredField($(this));
			} else {
				// eslint-disable-next-line no-lonely-if
				if (!$(this).hasClass('disabled')) {
					$('#container-' + $(this).val()).remove();
				}
			}
		});

		$('.required-fields').on('click', '.requireds', function showRequiredAsterisk() {
			var id = $(this).attr('id'),
				field_name = id.replace('field-', 'required-');

			if ($(this).prop('checked') === true) {
				$('#' + field_name).css('visibility', 'visible');
			} else {
				$('#' + field_name).css('visibility', 'hidden');
			}
		});
	}

	function addRequiredField($ojb)
	{
		var html = createInput(
			$ojb.val(),
			$ojb.data("name"),
			false,
			'<span class="required required-field-indicator" id="required-' + $ojb.val() + '"></span>',
			($ojb.data('type') === 'checkbox' ? 'disabled' : '')
		);

		$('.required-fields').append(html);
	}

	function createInput(value, name, checked, required, disabled)
	{
		var name_modified  = name.replace(/<\/?[^>]+(>|$)/g, ""),
			required_val   = required,
			style          = 'width: 300px;height: 34px;padding: 6px 12px;font-size: 14px;color: #555555;background-color: #fff;background-image: none;border-radius: 4px;box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;',

		// create the input html
		html = '<div class="checkbox" id="container-' + value +'" style="padding-bottom: 10px;"><label><input ' + disabled + ' id="field-' + value + '" value="' + value + '" checked="' + checked + '" class="requireds" type="checkbox" name="form_component_data[GroupEdit][requireds][]" style="margin-top: 10px;">' + required_val + ' <input id="textfield-' + value +'" style="' + style +'" type="text" value="' + name_modified.trim() +'" name="form_component_data[GroupEdit][labels][' + value + ']">&nbsp;&nbsp;<strong>CP Maxx Label:</strong>&nbsp;' + name + '</label></div>';

		return html;
	}

	function loadRequiredFields()
	{
		var html            = '';

		$('.fields').each(function getRequiredFields() {
			if ($(this).prop('checked') === true) {
				html += createInput(
					$(this).val(),
					$(this).data("name"),
					true,
					'<span class="required required-field-indicator" id="required-' + $(this).val() + '"></span>',
					($(this).data('type') === 'checkbox' ? 'disabled' : '')
				);
			}
		});

		$('.required-fields').html(html);
	}

	function loadLabels()
	{
		var label_field = $('#groupedit-labels').val();

		if (label_field.length > 0) {
			$.each(JSON.parse(label_field), function label(key, value) {
				$('#textfield-' + key).val(value);
			});
		}
	}

	function setRequiredFields()
	{
		var required_fields_json = $('#groupedit-required_fields').val(),
			required_fields;

		if (required_fields_json.length > 0) {
			required_fields = $.parseJSON($('#groupedit-required_fields').val());

			$('.requireds').each(function unCheckem() {
				$(this).prop('checked', false);
			});

			$('.required-field-indicator').each(function unDoit() {
				$(this).css('visibility', 'hidden');
			});

			$.each(required_fields, function thing(index, element) {
				$('.requireds').each(function checkem() {
					if ($(this).attr('id') === 'field-' + element) {
						$(this).prop('checked', true);
						$('#required-' + element).css('visibility', 'visible');
					}
				});
			});
		}
	}

	function toggleOnlineRegistration(ev) {
		var online_registrations = $(ev.currentTarget).is(':checked');

		if (online_registrations) {
			$('#online-registrations-fields').removeClass('hidden');
		} else {
			$('#online-registrations-fields').addClass('hidden');
		}
	}

	function toggleInsuranceSupplier(ev) {
		if ($(ev.currentTarget).val() === '0') {
			$('#insurance-supplier-container').removeClass('hidden');
		} else {
			$('#insurance-supplier-container').addClass('hidden');
		}
	}

	function toggleContentFields(ev) {
		if ($('#toggle-content-fields').hasClass("fa-plus-square")) {
			$('#toggle-content-fields').removeClass(GroupEditForm.maximizeClass);
			$('#toggle-content-fields').addClass(GroupEditForm.minimizeClass);
		} else {
			$('#toggle-content-fields').removeClass(GroupEditForm.minimizeClass);
			$('#toggle-content-fields').addClass(GroupEditForm.maximizeClass);
		}

		$('#group-content-div').collapse('toggle');
	}

	function handleExcludePaymentInfo(ev) {
		if ($(ev.currentTarget).is(':checked')) {
			$('.payment_box').each(function disableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('checked', false);
					$(el).prop('disabled', true);
				}
			});
		} else {
			$('.payment_box').each(function enableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('disabled', false);
				}
			});
		}
	}

	function handleSinglePaymentSource(ev) {
		if ($(ev.currentTarget).is(':checked')) {
			$('.payment_box').each(function disableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('checked', false);
					$(el).prop('disabled', true);
				}
			});
		} else {
			$('.payment_box').each(function enableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('disabled', false);
				}
			});
		}
	}

	function handleCardAuthorization(ev) {
		if ($(ev.currentTarget).is(':checked')) {
			$('#authorization-amount-type').removeClass('hidden');
		} else {
			$('#authorization-amount-type').addClass('hidden');
			$('#authorization-amount').addClass('hidden');
			$('#authorization-per-person').addClass('hidden');
			$('#groupedit-group-authorization_amount_type').val('total');
			$('#groupedit-group-authorization_amount').val('');
			$('#groupedit-group-authorization_per_person').prop('checked', false);
		}
	}

	function handleSetAuthorizationAmountType(ev) {
		if ($(ev.currentTarget).val() === 'custom') {
			$('#authorization-amount').removeClass('hidden');
			$('#authorization-per-person').removeClass('hidden');
		} else {
			$('#groupedit-group-authorization_amount').val('');
			$('#authorization-amount').addClass('hidden');
			$('#authorization-per-person').addClass('hidden');
		}
	}

	function updateBodyContent(template_id)
	{
		var editor, // eslint-disable-line no-unused-vars
		    new_content;

		Adzuki.Ajax.get(Adzuki.base_uri + '/WebsiteContentTemplates/getTemplateContent/' + template_id).then(
			function success(response) {
				editor = Adzuki.Editor('#groupedit-group-about', {
					init_instance_callback: function onEditorInit(_editor) {
						// get template content
						new_content = response.body;

						// set the editor to new content
						_editor.setContent(new_content);

						$('#groupedit-group-about').val(new_content);
					},
					height     : 400,
					content_css: $('#groupedit-group-about').data('content-css'),
				});
			}
		);
	}
}(jQuery, window.Adzuki || {}));